import { App as AntApp, ConfigProvider, Spin } from "antd";
import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import CookieConsentBanner from "./components/CookieConsentBanner";
import Layout from "./components/Layout";
import LegalTermsModal from "./components/LegalTermsModal";
import OnboardingModal from "./components/OnboardingModal";
import { AuthProvider } from "./context/AuthContext";
import { CookieConsentProvider } from "./context/CookieConsentContext";
import { LegalAcceptanceProvider } from "./context/LegalAcceptanceContext";
import AppRoutes from "./routes";
import { AppMessageBridge } from "./utils/appMessage";

export default function App() {
  return (
    <ConfigProvider
      theme={{
        token: { colorPrimary: "#183B75", colorLink: "#B05616", colorBgContainer: "#ffffff" },
        components: { Rate: { starSize: 50 } },
      }}
    >
      <AntApp>
        <AppMessageBridge />
        <BrowserRouter>
          <AuthProvider>
            <CookieConsentProvider>
              <LegalAcceptanceProvider>
                <Layout>
                  <Suspense
                    fallback={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          minHeight: "400px",
                        }}
                      >
                        <Spin />
                      </div>
                    }
                  >
                    <AppRoutes />
                  </Suspense>
                  <CookieConsentBanner />
                  <LegalTermsModal />
                  <OnboardingModal />
                </Layout>
              </LegalAcceptanceProvider>
            </CookieConsentProvider>
          </AuthProvider>
        </BrowserRouter>
      </AntApp>
    </ConfigProvider>
  );
}
